import { Link } from "react-router-dom";
import { useLanguage } from "../../contexts/LanguageContext";
import { SOLUTION_LANDINGS } from "../../data/solutionLandings";

const ITEMS = [
    "facebook-ad-account-disabled-recovery",
    "high-spend-google-ads-accounts",
    "agency-ad-account-vs-personal",
    "agency-ad-account-pricing-guide",
    "daily-spend-limit-solution",
];

export default function RelatedSolutionsStrip() {
    const { language } = useLanguage();

    return (
        <section
            data-testid="blog-related-solutions-strip"
            className="py-10 border-t border-white/[0.06]"
        >
            <div className="container-skala">
                <p className="text-[10px] font-mono uppercase tracking-[0.25em] text-primary mb-3">
                    {({ tr: "İlgili Çözüm Sayfaları", es: "Páginas de soluciones relacionadas", pt: "Páginas de soluções relacionadas", ru: "Связанные страницы решений" })[language] || "Related Solution Pages"}
                </p>
                <div className="flex flex-wrap gap-2">
                    {ITEMS.map((slug) => (
                        <Link
                            key={slug}
                            to={`/solutions/${slug}`}
                            data-testid={`blog-related-solution-${slug}`}
                            className="text-xs md:text-sm px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.02] hover:border-primary/40 hover:text-primary transition-colors"
                        >
                            {SOLUTION_LANDINGS[slug]?.title?.[language] || SOLUTION_LANDINGS[slug]?.title?.en || slug}
                        </Link>
                    ))}
                </div>
            </div>
        </section>
    );
}
